export const locale = {
    lang: 'es',
    data: {
        'MAIL_CONFIRM': {
            'TITLE': '¡Confirma tu dirección de correo electrónico!',
            'TEXT_1': 'La confirmación del correo ha sido enviada a ',
            'TEXT_2': 'Comprueba tu bandeja de entrada y haz click en "Confirmar mi email" para confirmar la dirección del correo electrónico.',
            'BACK': 'Ir a iniciar sesión',
            'VALIDATION': {
                'TITLE': '¡Enhorabuena!',
                'TEXT_1': 'ya puede acceder al panel de control.',
                'TEXT_2': 'La confirmación se ha llevado a cabo satisfactoriamente.'
            },
            'ERROR': {
                'TITLE': '¡Vaya!, parece que ha ocurrido un error.',
                'ERROR_INFO_1': 'El email no se ha encontrado.',
                'ERROR_INFO_2': 'No hemos encontrado su usuario.',
                'ERROR_INFO_3': 'Sus datos no coinciden.',
                'ERROR_INFO_4': 'Ha ocurrido un error mientras intentábamos activar su cuenta, inténtelo de nuevo más tarde.',
                'ERROR_INFO_5': 'Inténtelo de nuevo más tarde.',
                'ERROR_INFO_6': 'Sentimos las molestias.',
            }
        }
    }
};
